// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/styles/css/reset/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/styles/css/bootstrap/bootstrap.min.css'
import './assets/scripts/js/bootstrap/bootstrap.min'

/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/layout/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/layout/Footer'
Vue.component(Footer.name,Footer)

/* 右侧 */
import rightSide from './components/rightSide/RightSide'
Vue.component(rightSide.name,rightSide)

/* 回到顶部 */
import BackTop from './components/layout/BackTop'
Vue.component(BackTop.name,BackTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
       document.title = document.title.split(" - ")[0] +" - "+to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js